import store from '@state/store'
import { lazyLoadView } from '@utils/app/lazy-load-routes'
import { setInfo } from '@utils/app/select-info'
import toggle from '@utils/design/toggle-info'

export default [
  {
    path: '/insights',
    name: 'Insights',
    component: () => lazyLoadView(import('@views/insights/insights-bigboard')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        toggle(false)

        Promise.all([store.dispatch('info/setInfo', setInfo(routeTo.name))])
          .then(() => {
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: 'Login', params: { resource: 'Device State' } })
          })
      },
    },
  },
  {
    path: '/insights/explorer',
    name: 'Insights Explorer',
    component: () => lazyLoadView(import('@views/insights/insights')),
    props: { slug: 'dashboards' },
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        toggle(false)

        Promise.all([
          store.dispatch('info/setInfo', setInfo(routeTo.name)),
          store.dispatch('deviceInsights/doInsightsLogin', {
            clearCache: false,
          }),
        ])
          .then(() => {
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: 'Login', params: { resource: 'Insights Explorer' } })
          })
      },
    },
  },
]
